(function($) {
  const ebrochure = {
    dom: function() {
      this.$ebrochureForm = $('#ebrochure');
      this.$ebrochureError = $('#ebrochure-error');
      this.$ebrochureRow = $('[data-js-hook="ebrochure-row"]');
      this.$ebrochureEmailForm = $('#ebrochure-email');
      this.$ebrochureConfirm = $('#formConfirm');
      this.$checkbox = $('[data-js-hook="checkbox"]');
    },

    validateSelection: function() {
      this.$ebrochureForm.submit(function(e) {
        let checked = [];
        ebrochure.$checkbox.each(function() {
          if ($(this).prop('checked')) {
            checked.push(1);
          }
        });

        if (checked.length) {
          ebrochure.$ebrochureError.hide();
        }
        else {
          e.preventDefault();
          ebrochure.$ebrochureError.show();
        }
      });
    },

    emailForm: function() {
      if (this.$ebrochureEmailForm.length) {
        this.$ebrochureEmailForm.formulate({
          require: 'brochureEmail{email}',
          errorClass: 'error',
          errorParent: '[data-field-required]',
          showOnSubmit: '#ebrochure-confirm',
          inlineMsg: true,
          inlineMsgClass: 'form__inline-error',
          errorMsgContainer: '[data-form-error]',
        });
      }
    },

    rowSelect: function() {
      this.$checkbox.click(function(e) {
        e.stopPropagation();
        e.preventDefault();
      });

      this.$ebrochureRow.click(function(e) {
        let $checkbox = $('#' + $(this).data('checkbox'));
        if ($checkbox.prop('checked')) {
          $checkbox.prop('checked', false);
        }
        else {
          $checkbox.prop('checked', true);
        }
      });
    },

    ready: function() {
      this.dom();
      this.validateSelection();
      this.emailForm();
      this.rowSelect();
    }
  };

  $(function() {
    ebrochure.ready();
  });
})(jQuery);
